'use client';

import React from 'react';
import { Box, BoxProps, useTokens } from '@mezzoforte/forge';

const { fontSizes, fontWeights, lineHeights, breakpoints } = useTokens.huutokaupat;

function NavContainer(props: BoxProps) {
  return (
    <Box
      as="nav"
      backgroundColor="brandSecondary"
      position={{ base: 'fixed', lg: 'static' }}
      data-test="main-navigation"
      sx={{
        fontFamily: 'var(--heading-font-family)',
        fontSize: fontSizes.button,
        fontWeight: fontWeights.button,
        lineHeight: lineHeights.button,
        paddingBottom: 'env(safe-area-inset-bottom)',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 'var(--chakra-zIndices-modal)',
        _after: {
          content: '""',
          position: 'fixed',
          height: 'calc(100vh + 80px)',
          top: '74px', // SiteHeader.NAV_HEIGHT
          left: 0,
          right: 0,
          background: 'rgba(0, 0, 0, 0.5)',
          zIndex: -1,
          display: 'none',
        },
        '&:has([aria-expanded="true"])': {
          _after: {
            display: 'block',
          },
        },
        [`@media screen and (max-width: ${breakpoints.lg})`]: {
          _after: {
            top: 0,
          },
          '& ~ body': {
            marginBottom: '60px',
          },
        },
      }}
      {...props}
    />
  );
}

export default NavContainer;
